import { userControl } from '../axios';
export default {
	// 登录
	login_sys({ commit },userinfo){
		userControl.login(userinfo).then(res => {
			// state.token=res.token;
			// console.log(state.token)
			
			commit('setUserInfo',res);
		})
	},
}